import React from "react";

function NoOrderLogs() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#ffb954"
        d="M440.93 375.7L256 477.245 71.07 375.7V172.61L256 71.063l184.93 101.546zm0 0"
        data-original="#ffb954"
      ></path>
      <path
        fill="#fea02c"
        d="M71.07 172.61v.003L256 274.16l184.93-101.547v-.004L256 71.063zm0 0"
        data-original="#fea02c"
      ></path>
      <path
        fill="#ffc66c"
        d="M71.07 172.672v203.027L256 477.246l.11-.059v-203.03L71.18 172.608zm0 0"
        data-original="#ffc66c"
      ></path>
      <path
        fill="#feda9b"
        d="M440.93 172.613L502 233.68 317.07 335.227 256 274.157zm-369.86 0L10 233.68l184.93 101.547 61.07-61.07zm369.86 0L502 111.547 317.07 10 256 71.07zm-369.86 0L10 111.547 194.93 10 256 71.07zm0 0"
        data-original="#feda9b"
      ></path>
      <path
        d="M455.074 172.613l53.996-53.996a10 10 0 00-2.258-15.836l-64.914-35.644c-4.84-2.657-10.918-.887-13.578 3.953-2.656 4.844-.89 10.922 3.953 13.578l53.235 29.23-46.34 46.336L272.5 68.714l46.336-46.335 46.84 25.723c4.84 2.656 10.922.89 13.578-3.954 2.66-4.84.89-10.921-3.953-13.578L321.883 1.234A9.996 9.996 0 00310 2.93l-54 54-54-54a10.003 10.003 0 00-11.883-1.696L5.187 102.781a9.994 9.994 0 00-5.085 7.356 9.987 9.987 0 002.828 8.48l53.996 53.996L2.93 226.605a9.994 9.994 0 00-2.828 8.485 9.987 9.987 0 005.086 7.351L61.07 273.13V375.7c0 3.653 1.989 7.012 5.188 8.77l184.93 101.543c1.5.824 3.156 1.234 4.812 1.234s3.313-.41 4.813-1.234l184.93-101.543a10.004 10.004 0 005.187-8.77V273.13l55.883-30.684a10 10 0 002.257-15.836zM256 262.746L91.848 172.61 256 82.47l164.152 90.14zM193.168 22.38L239.5 68.715l-166.668 91.52-46.336-46.337zM72.84 184.989l166.668 91.519-46.34 46.34-166.672-91.52zm358.09 184.796L266 460.348V358.125c0-5.523-4.477-10-10-10s-10 4.477-10 10v102.223L81.07 369.785v-85.672l109.047 59.88A10 10 0 00202 342.297l54-54.001 54 54a9.984 9.984 0 007.074 2.93c1.64 0 3.297-.407 4.809-1.235l109.047-59.879zm-112.094-46.937l-46.34-46.344 166.668-91.516 46.344 46.336zm0 0"
        data-original="#000000"
      ></path>
      <path
        d="M404.8 68.176c2.63 0 5.2-1.07 7.071-2.934a10.07 10.07 0 002.93-7.066c0-2.633-1.07-5.211-2.93-7.07a10.063 10.063 0 00-7.07-2.93 10.04 10.04 0 00-7.07 2.93 10.023 10.023 0 00-2.93 7.07 10.02 10.02 0 002.93 7.066 10.067 10.067 0 007.07 2.934zM256 314.926a10.06 10.06 0 00-7.07 2.93 10.087 10.087 0 00-2.93 7.07c0 2.636 1.07 5.207 2.93 7.078 1.86 1.86 4.441 2.922 7.07 2.922s5.21-1.063 7.07-2.922a10.105 10.105 0 002.93-7.078c0-2.633-1.07-5.203-2.93-7.07a10.063 10.063 0 00-7.07-2.93zm0 0"
        data-original="#000000"
      ></path>
    </svg>
  );
}

export default NoOrderLogs;